import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Syringe, Heart, HandCoins, Stethoscope, Sparkles } from 'lucide-react';
// Nota: 'Sparkles' debe importarse si lo usas.

import imag16 from '../assets/images/imag16.jpeg';
const Hero = () => {
    const features = [
        { icon: Syringe, text: "Terapias Naturales y Seguras" },
        { icon: Stethoscope, text: "Tratamientos Personalizados" },
        { icon: Heart, text: "Resultados Reales y Duraderos" },
        { icon: HandCoins, text: "Precios Justos" }
    ];

    return (
        <section id="home" className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 pt-20">
            <div className="container mx-auto px-4 py-16">
                <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[80vh]">
                    {/* Columna Izquierda (Texto) */}
                    <motion.div
                        className="space-y-8"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        {/* Logo y Titulos */}
                        <motion.div 
                            className="flex items-center gap-4 mb-6"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.1, duration: 0.6 }}
                        >
                            <img
                                src="https://utfs.io/f/5BN0V4mlt4NUrOWP0qz5NPcaAgwizpdKqn4rb3Q1IHGDuV67"
                                alt="Bienestar Al Natural Logo"
                                className="w-20 h-20 shadow-lg object-cover"
                            />
                            <div className="flex flex-col">
                                <h6 className="text-lg text-green-900 font-semibold">Bienestar al Natural</h6>
                                <p className="text-sm font-medium text-gray-600">Tu Centro de Salud y Belleza</p>
                            </div>
                        </motion.div>
                        
                        <motion.h1 
                        className="text-3xl md:text-4xl lg:text-6xl font-bold leading-snug md:leading-normal lg:leading-[1.1] tracking-tight md:tracking-normal max-w-4xl text-left"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                        >
                        <span className="bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
                            Tu Bienestar, desde adentro hacia afuera
                        </span>
                        </motion.h1>

                        <motion.p 
                            className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4, duration: 0.8 }}
                        >
                            Unimos la medicina alternativa, la medicina homeopática, la estética facial y corporal para 
                            equilibrar tu salud, tu energía y tu belleza.
                        </motion.p>

                        <motion.p 
                            className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.5, duration: 0.8 }}
                        >
                            En Bienestar al Natural creemos que la transformación empieza desde el interior. Por esto, combinamos terapias naturales,
                            medicina regenerativa y estética avanzada para ayudarte a sentir pleno por dentro y radiante por fuera.
                        </motion.p>

                        
                        {/* Features (Íconos) */}
                        <motion.div 
                            className="flex flex-wrap gap-6"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.6, duration: 0.8 }}
                        >
                            {features.map((feature, index) => (
                                <motion.div
                                    key={index}
                                    className="flex items-center gap-3 bg-white/80 backdrop-blur-sm px-4 py-3 rounded-full shadow-md"
                                    whileHover={{ scale: 1.05, y: -2 }}
                                    transition={{ delay: index * 0.1 }}
                                >
                                    <feature.icon className="w-5 h-5 text-green-600" />
                                    <span className="font-medium text-gray-700">{feature.text}</span>
                                </motion.div>
                            ))}
                        </motion.div>

                        {/* Botones */}
                        <motion.div 
                            className="flex flex-col sm:flex-row gap-4"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.8, duration: 0.8 }}
                        >
                           <motion.a
                            href={`https://wa.me/573237076868?text=${encodeURIComponent("Hola, los vi en su website y quiero obtener más información sobre sus servicios")}`}
                            className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-8 py-4 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 text-center"
                            whileHover={{ scale: 1.05, y: -2 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Contáctanos Ahora
                            </motion.a>

                            <motion.a
                                href="#services"
                                className="border-2 border-green-600 text-green-600 px-8 py-4 rounded-full font-semibold hover:bg-green-600 hover:text-white transition-all duration-300 text-center"
                                whileHover={{ scale: 1.05, y: -2 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                Conoce Nuestros Servicios
                            </motion.a>
                        </motion.div>
                    </motion.div>
                    {/* FIN Columna Izquierda */}


                    {/* Columna Derecha (Imagen) */}
                    <motion.div
                        className="relative"
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.3 }}
                    >
                        <div className="relative rounded-3xl">
                        <img
                            src={imag16}
                            alt="Productos naturales Bienestar al Natural"
                            className="w-full h-96 object-cover rounded-2xl"
                        />
                        <motion.div
                            className="absolute -top-4 -right-4 bg-white p-4 rounded-full shadow-lg"
                            animate={{ rotate: 360 }}
                            transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                        >
                            <Sparkles className="w-8 h-8 text-green-600" />
                        </motion.div>
                        </div>
                        </motion.div>
                        {/* FIN Columna Derecha */}
                    </div> {/* Cierra el div del grid lg:grid-cols-2 */}

                <motion.div 
                    className="text-center mt-16"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1.2, duration: 0.8 }}
                >
                    <motion.div
                        animate={{ y: [0, 10, 0] }}
                        transition={{ duration: 2, repeat: Infinity }}
                    >
                        <ArrowDown className="w-8 h-8 text-green-600 mx-auto" />
                    </motion.div>
                </motion.div>
            </div> {/* Cierra el div del container mx-auto */}
        </section>
    );
};

export default Hero;